import { Form } from 'react-bootstrap'
import { UseFormRegisterReturn } from 'react-hook-form'
import Attachment from '@/types/Attachment'
import { forwardRef } from 'react'
import AttachmentControl, { onAttachmentDeletedCallback } from '@/components/AttachmentControl'

export enum FileFormat {
  any = '*/*',
  image = 'image/*',
  audio = 'audio/*',
  video = 'video/*',
}

interface Props extends Omit<UseFormRegisterReturn, 'ref'> {
  title: string,
  accept: FileFormat[],
  attachments?: Attachment[]
  multiple?: boolean
  onAttachmentDeleted?: onAttachmentDeletedCallback
}

const FileInput = forwardRef<HTMLInputElement, Props>(function FileInput({
  title,
  accept,
  attachments,
  onAttachmentDeleted,
  ...registerProps
}: Props, ref) {
  return (
    <Form.Group>
      <Form.Label>{title}</Form.Label>
      <Form.Control
        type="file"
        accept={accept.join(',')}
        {...registerProps}
        ref={ref}
      />
      <div className="d-flex flex-column m-2 gap-1">
        {attachments?.map(attachment => (
          <AttachmentControl
            attachment={attachment}
            key={attachment.id}
            onAttachmentDeleted={onAttachmentDeleted}
          />
        ))}
      </div>
    </Form.Group>
  )
})

export default FileInput
